"use strict";

async function initMap() {
  var map = void 0;

  var _ref = await google.maps.importLibrary("maps"),
      Map = _ref.Map;

  var center = void 0,
      zoom = void 0;
  if (ONIBUS.data.$MQ === 'PORTRAIT') {
    center = { lat: 39.387777, lng: 127.257232 };
    zoom = 1.75;
  } else {
    center = { lat: 20.024, lng: 130.887 };
    zoom = 2;
  }

  map = new Map(document.getElementById("map"), {
    center: center,
    zoom: zoom,
    // mapId: 'b8263c2a6c546851', //dev
    mapId: '5db2b370a2d72b81', //本番
    styles: [{
      "featureType": "poi",
      "stylers": [{
        "visibility": "off"
      }]
    }]
  });

  var infoWindow = new google.maps.InfoWindow({
    content: "",
    disableAutoPan: true
  });

  // マーカーを準備する。partner_shop_objはliquidでグローバル変数として定義してある。
  var markers = partner_shop_obj.map(function (shop, i) {
    var link = shop.link ? "<a class=\"infoWindow_link c-textLink\" href=\"" + shop.link + "\" class=\"infoWindow_link\" target=\"_blank\">GoogleMap\u3092\u898B\u308B</a>" : '';
    var content = '<div class="infoWindow_content">' + ("<h1 class=\"infoWindow_title\">" + shop.shop_name + "</h1>") + ("<p class=\"infoWindow_address\">" + shop.address + "</p>") + link + '</div>';

    var marker = new google.maps.Marker({
      position: {
        lat: Number(shop.latitude),
        lng: Number(shop.longitude)
      },
      icon: {
        url: 'https://cdn.shopify.com/s/files/1/0868/4162/2804/files/image.svg.icon_marker.svg'
      }
    });

    marker.addListener('click', function () {
      infoWindow.setContent(content);
      infoWindow.open(map, marker);
    });

    return marker;
  });

  // Add a marker clusterer to manage the markers.
  var markerCluster = new markerClusterer.MarkerClusterer({
    map: map,
    markers: markers,
    renderer: {
      render: function render(_ref2) {
        var count = _ref2.count,
            position = _ref2.position;
        return (
          // クラスターのカスタム
          new google.maps.Marker({
            icon: {
              url: 'https://cdn.shopify.com/s/files/1/0868/4162/2804/files/image.svg.icon_cluster.svg'
            },
            label: {
              text: String(count),
              color: 'white',
              fontSize: '20px',
              fontWeight: 'bold'
            },
            position: position,
            // 他のマーカーの上になるよう調整
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
          })
        );
      }
    }
  });
}

initMap();